/* Alice Cress — product page: size selection, size-filtered gallery, sticky add-to-cart, monogram. */
(function () {
  if (customElements.get('ac-product')) return;

  const cleanInitials = (value) => value.replace(/[^a-z]/gi, '').toUpperCase().slice(0, 3);
  const newLink = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

  class ACProduct extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('.pdp-slide'));
      this.thumbs = Array.from(this.querySelectorAll('.pdp-thumb'));

      this.querySelectorAll('[data-size-input]').forEach((input) =>
        input.addEventListener('change', () => this.select(input.value, true))
      );
      this.thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => this.goTo(this.slides[Number(thumb.dataset.index)]))
      );
      this.querySelectorAll('[data-step]').forEach((btn) =>
        btn.addEventListener('click', () => this.step(Number(btn.dataset.step)))
      );
      this.querySelectorAll('[data-qty]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const input = btn.parentElement.querySelector('input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty));
        })
      );

      if (this.track && 'IntersectionObserver' in window) {
        this.slideObserver = new IntersectionObserver(
          (entries) => entries.forEach((e) => e.isIntersecting && this.setActive(e.target)),
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((s) => this.slideObserver.observe(s));
      }

      this.initSticky();
      this.initMonogram();
      const checked = this.querySelector('[data-size-input]:checked');
      const variant = checked && this.findVariant(checked.value);
      this.filterGallery(checked ? checked.dataset.token : null, variant ? variant.media : null);
      this.querySelectorAll('[data-restock]').forEach((box) => {
        if (this.restockPosted(box)) box.hidden = false;
      });
    }

    disconnectedCallback() {
      if (this.slideObserver) this.slideObserver.disconnect();
      if (this.stickyObserver) this.stickyObserver.disconnect();
    }

    // After a sign-up, Shopify reloads the page at #<form id>; keep the thank-you visible.
    restockPosted(box) {
      return window.location.hash === `#${box.dataset.restockForm}`;
    }

    findVariant(id) {
      return this.variants.find((v) => String(v.id) === String(id));
    }

    select(id, updateUrl) {
      const v = this.findVariant(id);
      if (!v) return;
      const radio = this.querySelector(`[data-size-input][value="${v.id}"]`);
      if (radio) radio.checked = true;

      this.querySelectorAll('[data-variant-input]').forEach((el) => (el.value = v.id));
      this.querySelectorAll('[data-price]').forEach((el) => (el.textContent = v.price));
      this.querySelectorAll('[data-compare]').forEach((el) => {
        el.textContent = v.compare || '';
        el.hidden = !v.compare;
      });
      this.querySelectorAll('[data-unit]').forEach((el) => {
        el.textContent = v.unit || '';
        el.hidden = !v.unit;
      });
      this.querySelectorAll('[data-size-selected]').forEach((el) => (el.textContent = v.size));
      this.querySelectorAll('[data-add]').forEach((btn) => {
        btn.disabled = !v.available;
        const label = btn.querySelector('[data-add-label]');
        if (label) label.textContent = v.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        const price = btn.querySelector('[data-add-price]');
        if (price) {
          price.textContent = ` · ${v.price}`;
          price.hidden = !v.available;
        }
      });
      this.querySelectorAll('[data-restock]').forEach((box) => {
        box.hidden = v.available && !this.restockPosted(box);
        const tags = box.querySelector('input[name="contact[tags]"]');
        if (tags) tags.value = `newsletter,back-in-stock,back-in-stock-${v.token}`;
      });
      this.querySelectorAll('[data-note]').forEach((note) => {
        const sizes = note.dataset.note;
        note.hidden = sizes ? !sizes.split(',').includes(v.token) : false;
      });

      this.filterGallery(v.token, v.media);

      if (updateUrl) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* file:// previews and sandboxed frames */ }
      }
    }

    /* Show this size's images first, then images tagged for every size. */
    filterGallery(token, mediaId) {
      if (!this.slides.length) return;
      const hasOwn = token && this.slides.some((s) => s.dataset.tag === token);
      this.slides.forEach((slide, i) => {
        const own = hasOwn && slide.dataset.tag === token;
        const visible = !hasOwn || own || slide.dataset.tag === 'all';
        const order = own ? '0' : '1';
        slide.hidden = !visible;
        slide.style.order = order;
        if (this.thumbs[i]) {
          this.thumbs[i].hidden = !visible;
          this.thumbs[i].style.order = order;
        }
      });
      const visible = this.visibleSlides();
      this.classList.toggle('pdp-single', visible.length < 2);
      const target =
        (mediaId && visible.find((s) => s.dataset.mediaId === String(mediaId))) || visible[0];
      this.goTo(target, false);
    }

    visibleSlides() {
      return this.slides
        .filter((s) => !s.hidden)
        .sort((a, b) => a.style.order - b.style.order || this.slides.indexOf(a) - this.slides.indexOf(b));
    }

    goTo(slide, smooth = true) {
      if (!slide || !this.track) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      this.setActive(slide);
    }

    step(dir) {
      const visible = this.visibleSlides();
      if (visible.length < 2) return;
      const i = Math.max(0, visible.indexOf(this.active));
      this.goTo(visible[(i + dir + visible.length) % visible.length]);
    }

    setActive(slide) {
      if (!slide || slide.hidden) return;
      this.active = slide;
      const index = this.slides.indexOf(slide);
      this.thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    }

    /* With a monogram ticked, the product and its monogram go into the cart in one request,
       tied by a hidden key: _monogram on the product line, _for on the monogram line. */
    initMonogram() {
      const box = this.querySelector('[data-monogram]');
      const form = this.querySelector('.pdp-form');
      if (!box || !form) return;
      const toggle = box.querySelector('[data-mono-toggle]');
      const fields = box.querySelector('[data-mono-fields]');
      const input = box.querySelector('[data-mono-input]');
      const error = box.querySelector('[data-mono-error]');
      const showError = (message) => {
        error.textContent = message;
        error.hidden = !message;
      };
      box.hidden = false;

      toggle.addEventListener('change', () => {
        fields.hidden = !toggle.checked;
        showError('');
        if (toggle.checked) input.focus();
      });
      input.addEventListener('input', () => {
        input.value = cleanInitials(input.value);
        showError('');
      });

      form.addEventListener('submit', (event) => {
        if (!toggle.checked) return;
        event.preventDefault();
        const initials = input.value;
        if (!/^[A-Z]{1,3}$/.test(initials)) {
          showError(box.dataset.invalid);
          input.focus();
          return;
        }
        const data = new FormData(form);
        const quantity = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
        const link = newLink();
        const properties = { _monogram: link };
        data.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        });
        const buttons = this.querySelectorAll('[data-add]');
        buttons.forEach((btn) => (btn.disabled = true));
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(data.get('id')), quantity, properties },
              { id: Number(box.dataset.monoVariant), quantity, properties: { Initials: initials, _for: link } },
            ],
          }),
        })
          .then((res) => (res.ok ? res.json() : res.json().then((err) => Promise.reject(err))))
          .then(() => {
            window.location.href = `${root}cart`;
          })
          .catch((err) => {
            buttons.forEach((btn) => (btn.disabled = false));
            showError((err && err.description) || box.dataset.failed);
          });
      });
    }

    /* Phone bar shows once the main Add to cart button has scrolled above the viewport. */
    initSticky() {
      const bar = this.querySelector('[data-sticky]');
      const main = this.querySelector('[data-main-add]');
      if (!bar || !main || !('IntersectionObserver' in window)) return;
      this.stickyObserver = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        bar.querySelectorAll('button').forEach((b) => (b.tabIndex = show ? 0 : -1));
      });
      this.stickyObserver.observe(main);
    }
  }

  customElements.define('ac-product', ACProduct);

  /* "Choose this size" links in other sections select the size in place instead of reloading. */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-select-variant]');
    const product = document.querySelector('ac-product');
    if (!link || !product || !product.findVariant(link.dataset.selectVariant)) return;
    event.preventDefault();
    product.select(link.dataset.selectVariant, true);
    product.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
